<template>
<div class="chapter">
<div class="inner_page">
<div class="fmtitle"><a id="page_vii"></a><a href="#/contents#fm-1" id="fm1"><span class="black"><i>Preface</i></span></a></div>
<div class="noindent"><span class="drop-cap">T</span>his is a brief, narrative history of Texas written for the adult reader who wishes to probe into the ethos of a people, taste the unique flavor of the culture, and experience the rhythm of development. In the story you will find triumph and tragedy, sadness and humor, cruelty and compassion, exuberance and depression. It wasn’t always easy to be a Texan; it still isn’t.<a id="page_viii"></a><a id="page_ix"></a><a id="page_x"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface.vue?503445b3